import { isSupportedItemType } from "./../../../../utils/item-type-checker";
import { SFMLElement, SFMLAnnotatable } from "~/renderer/web-components/element";
import { ItemType, PAYLOAD_PREFIX } from "~/parse/sfml-ast";
import * as AST from "~/parse/sfml-ast";

import * as S from "~/styles/sfml.css";
import * as C from "~/constants";

export class ImageAnchor extends SFMLElement implements SFMLAnnotatable {
  private _anchor: HTMLAnchorElement | null = null;
  private annotationElement: HTMLDivElement | null = null;

  private annotatedImageUrl: string | null = null;

  constructor() {
    super();

    this.setAttribute("annotatable", "");
  }

  public get itemType(): ItemType | null {
    const itemType = this.getAttribute("item-type") as ItemType;
    if (!itemType) return null;

    if (!isSupportedItemType(itemType)) return null;

    return itemType;
  }

  public get targetAnchorId(): string | null {
    const targetAnchorId = this.getAttribute("target-anchorId");

    return targetAnchorId;
  }

  public get itemId() {
    return this.getAttribute("source-id");
  }

  private appendAnnotation() {
    if (!this._anchor) return;

    if (!this.annotatedImageUrl) return;

    this.annotationElement = document.createElement("div");
    this.annotationElement.style.backgroundImage = `url(${this.annotatedImageUrl})`;
    this.annotationElement.classList.add(S.annotation);
    this.annotationElement.classList.add(`flipp-${this.itemType}-annotation`);
    this._anchor.appendChild(this.annotationElement);
  }

  private onAnchorClickHandler = (e: Event) => {
    e.preventDefault();

    const actionType = this.getAttribute("action-type");

    if (actionType && actionType === AST.Action.LINK) {
      this.handleLinkClick(e);
    } else {
      this.handleItemClick(e);
    }
  };

  private handleLinkClick = (_: Event) => {
    const event = new CustomEvent(C.LINK_CLICK_EVENT, {
      bubbles: true,
      detail: { ttmUrl: this.getAttribute("ttm-url") }
    });
    this.dispatchEvent(event);
  }

  private handleItemClick = (e: Event) => {
    const itemType = this.getAttribute("item-type") as ItemType;
    if (!itemType || !isSupportedItemType(itemType)) return;

    const itemId = this.getAttribute("source-id");
    if (!itemId) return;

    const targetAnchorId = this.getAttribute("target-anchor-id");

    const payload: { [key: string]: string } = {};
    for (let i = 0, n = this.attributes.length; i < n; ++i) {
      const attr = this.attributes[i];
      if (attr.name.startsWith(PAYLOAD_PREFIX)) {
        payload[attr.name.slice(PAYLOAD_PREFIX.length)] = attr.value;
      }
    }

    const event = new CustomEvent(C.ITEM_CLICK_EVENT, {
      bubbles: true,
      detail: { itemType, itemId, targetAnchorId, payload },
    });
    this.dispatchEvent(event);
  }

  public get anchor(): HTMLAnchorElement | null {
    return this._anchor;
  }

  public set anchor(anchor: HTMLAnchorElement | null) {
    if (this._anchor) this._anchor.removeEventListener("click", this.onAnchorClickHandler);

    this._anchor = anchor;

    if (!this._anchor) return;

    this._anchor.addEventListener("click", this.onAnchorClickHandler, false);

    if (this.isAnnotated()) {
      this.appendAnnotation();
    }
  }

  public annotate(imageUrl: string) {
    this.annotatedImageUrl = imageUrl;
    if (!this._anchor) return;

    this.appendAnnotation();
  }

  public isAnnotated() {
    return !!this.annotatedImageUrl;
  }

  public clearAnnotation() {
    if (this._anchor && this.annotationElement) this._anchor.removeChild(this.annotationElement);

    this.annotationElement = null;
    this.annotatedImageUrl = null;
  }
}



// WEBPACK FOOTER //
// webpack://SFMLWeb/src/renderer/web-components/image/util/image-anchor.ts